import { serviceControllers } from '../util/enumerators';
import HttpService from './http.service';

const basePath = serviceControllers.USER;

export const UserService = {
  getAvailableProfiles,
};

async function getAvailableProfiles() {
  return HttpService.get(`${basePath}/profiles/available`);
}

export default UserService;


